export const profilefun=[
    {
        id:1,
        Name:"DMate Account"
    },
    {
        id:2,
        Name:"Refer Status"
    },{
        id:3,
        Name:"Enquiry"
    },
    {
        id:4,
        Name:"Trade online"
    },
    {
        id:5,
        Name:"Back office"
    }
]